<!-- =========================================================================================
    File Name: TableStriped.vue
    Description: Rendering default table with striped style
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>

    <div id="data-list-list-view" class="data-list-container">

        <vs-popup style="" class="holamundo"  title="Documentos:" :active.sync="popupActiveDocumentos2">
            <p>

                <vs-button style="margin: 5px" @click="ver_archivo(datos_candidato.foto)">foto</vs-button>
                <vs-button style="margin: 5px" @click="ver_archivo(datos_candidato.certificado)">certificado</vs-button>
                <vs-button style="margin: 5px" @click="ver_archivo(datos_candidato.acta)">acta</vs-button>
            <br/>
                <vs-button style="margin: 5px" @click="ver_archivo(datos_candidato.acta2)">Acta de nacimiento</vs-button>
                <vs-button style="margin: 5px" @click="ver_archivo(datos_candidato.curp2)">CURP</vs-button>
                <vs-button style="margin: 5px" @click="ver_archivo(datos_candidato.comprobante)">Comprobante de domicilio</vs-button>
                <vs-button style="margin: 5px" @click="ver_archivo(datos_candidato.certificado2)">Certificado</vs-button>
                <vs-button style="margin: 5px" @click="ver_archivo(datos_candidato.pago)">Registro de pago</vs-button>
                <vs-button style="margin: 5px" @click="ver_archivo(datos_candidato.ceneval)">Pase ceneval</vs-button>

           </p><br/>
            </vs-popup>




<vx-card title="Consultar Documentos Aspirantes de admisión"> 
<div class="container text-center">
  <div class="row">
        <div class="col-4"> Consultar por Fecha de Examen de admisón  
                   <v-select placeholder="seleccione una fecha" label="fecha" @change="onChangeFechas(fecha_admision.id)" v-model="fecha_admision" :options="fechas_examen">
                    </v-select>   
        </div>
         <div class="col-2">
         <!-- <span class="alert alert-info" role="alert"> {{cantidad_aspirantes_fecha}}   </span> -->
         <div v-show="cantidad_aspirantes_fecha>1" class="alert alert-info" role="alert"> Total de aspirantes: <b>{{cantidad_aspirantes_fecha}}  </b> </div>
        </div>


        <div class="col-6" >
             <vs-button  color="danger" style="margin: 2px 2px;"  @click="ver_todos()">Ver todos los registros de candidatos</vs-button>
        </div>


   </div>
  </div>
</vx-card> 


       <!-- <vs-table ref="table" pagination :max-items="itemsPerPage" search :data="aspirantes"> -->
             <vs-table ref="table" pagination :max-items="100" stripe search :data="documentos_aspirantes">

            <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                <!-- ITEMS PER PAGE -->
            </div>

            <template slot="thead">
                <vs-th>Número</vs-th>
                <vs-th sort-key="id">id</vs-th>
                <vs-th>Curp</vs-th>
                <vs-th>Correo</vs-th>
                <vs-th>Nombre</vs-th>
                <!--vs-th>Referencia</vs-th-->


                <vs-th sort-key="fecha_admision">Fecha de Admision</vs-th>
                 <vs-th>Carrera</vs-th>
                  <vs-th>Expedientes</vs-th>
                <vs-th>Detalles</vs-th>
            </template>

            <template slot-scope="{data}">
                <tbody>
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td>
                        <p class="product-name font-medium">{{ indextr + 1 }}</p>
                    </vs-td> 
                    
                    <vs-td>
                        <p class="product-name font-medium">{{ tr.idc }}</p>
                    </vs-td>

                    <vs-td>
                        <p class="product-category">{{ tr.curp }}</p>
                    </vs-td>
                    <vs-td>
                        {{ tr.correo }}
                     </vs-td>
                     <vs-td>
                          <p> {{tr.apaterno}} {{tr.amaterno}} {{tr.nombres}}</p>
                      </vs-td>
 <vs-td>
                          <p> {{tr.fecha_admision}}</p>
                      </vs-td>
                    <vs-td>
                          <p> {{tr.carrera}}</p>
                      </vs-td>
                   

                   
                    <vs-td v-if="tr.action == 1">

                        <vs-button @click="cambiar_estatus(tr.statusId, tr.idc)" size="small" color="primary" type="gradient">
                        {{tr.statusDescripcion}}</vs-button>

                    </vs-td>
                    <vs-td v-else>

                        <vs-button size="small" color="primary" type="border">{{tr.statusDescripcion}}</vs-button>

                    </vs-td>

                    <vs-td :data="tr.id">
                        <vs-button size="small" @click="detalles_candidato(tr.idc)" color="success" type="gradient">Ver Ficha</vs-button>
                    </vs-td>


                </vs-tr>
                </tbody>
            </template>
        </vs-table>
    </div>

</template>

<script>
    import vSelect from 'vue-select'
    export default {
        data() {
            return {
                 id_rol: this.getKey('id_rol'), 
                idc: 0,
                status_actual: 0,
                documentos_aspirantes: [],
                selected: [],
                users: [],
                itemsPerPage: 500,
                isMounted: false,
                addNewDataSidebar: false,
                popupActiveDocumentos2:false,
                datos_candidato: '[{}]',
                cantidad_aspirantes_fecha:'',
                fechas_examen:[],
                fecha_admision:{},

            }
        },
        computed: {
            currentPage() {
                if(this.isMounted) {
                    return this.$refs.table.currentx;
                }
                return 0;
            },
        },
        components: {
            'v-select': vSelect
        },
        created() {
        if(this.id_rol == 1 || this.id_rol == 5){
            this.getFechasExamen();

              }
        },
        mounted() {
            this.isMounted = true;
        },
        watch: {
            // whenever question changes, this function will run
            status_actual: function(){
               // alert(this.status_actual);
                this.muestra_modal();
            },
        },

        methods: {

            onChangeFechas(fecha_admision){
             
                     this.getAspirantes(fecha_admision);  
                                           
            },
            getFechasExamen() {
                this.$http.get("fechasAdmisionTodas").then(
                    response => {     
                        this.fechas_examen = response.data.fechasAdmisionTodas;
                          },
                    error => {
                        this.steperror(error);
                    }
                );
            },

            ver_archivo(id){
                window.open('https://cdn.upbicentenario.edu.mx/candidatos_1_2021/' + id);
            },
            cambiar_estatus(status, idc){
                this.status_actual = status
                this.idc = idc
            },
      
            get_datos_candidato(){
                this.$http.get("get_datos_candidato/" + this.idc).then(
                    response => {
                        // console.log(response.data)
                        this.datos_candidato = response.data.datos[0];
                        //console.log(this.kardex);

                    },
                    error => {
                        this.steperror(error);
                    }
                );
            },
            muestra_modal(){
              
                if(this.status_actual == 12){
                    this.get_datos_candidato()
                    this.popupActiveDocumentos2 = true;
                    this.status_actual = false;
                   // this.idc = false;
                }


            },
            detalles_candidato(id){
                window.open('https://cdn.upbicentenario.edu.mx/api/pdf_ficha/' + id)
            },


            ver_todos(){
                //  alert("Por favor espere, seguida traemos todos los aspirantes!....");
                this.getAspirantes();
            },
            getAspirantes(idfechaSelect){
                //   var idfechaSelect='';
                //    idfechaSelect=this.fecha_admision.id;
                this.$http.post("documentos_aspirantes",{idFecha:idfechaSelect}).then(
                    response => {
                        // console.log(response.data)
                        this.documentos_aspirantes = response.data.documentos_aspirantes;
                         this.cantidad_aspirantes_fecha= this.documentos_aspirantes.length;
                        //console.log(this.kardex);

                    },
                    error => {
                        this.steperror(error);
                    }
                );
            },

        },
    }
</script>


<style lang="scss">
    p{

            text-transform: uppercase;
        font-size: 12px !important;

    }
    #data-list-list-view {
        .vs-con-table {

            .vs-table--header {
                display: flex;
                flex-wrap: wrap-reverse;
                margin-left: 12px;
                margin-right: 12px;
                > span {
                    display: flex;
                    flex-grow: 1;
                }

                .vs-table--search{
                    padding-top: 0;

                    .vs-table--search-input {
                        padding: 0.9rem 1rem;
                        font-size: 12px;

                        &+i {
                            left: 1rem;
                        }

                        &:focus+i {
                            left: 1rem;
                        }
                    }
                }
            }

            .vs-table {
                border-collapse: separate;
                border-spacing: 0 1.3rem;
                padding: 0 1rem;

                tr{
                    box-shadow: 0 4px 5px 0 rgba(0,0,0,.05);
                    td{
                        padding: 5px;
                        &:first-child{
                            border-top-left-radius: 5px;
                            border-bottom-left-radius: 5px;
                        }
                        &:last-child{
                            border-top-right-radius: .5rem;
                            border-bottom-right-radius: .5rem;
                        }
                    }
                    td.td-check{
                        padding: 5px !important;
                    }
                }
            }

            .vs-table--thead{
                th {
                    padding-top: 0;
                    padding-bottom: 0;

                    .vs-table-text{
                        text-transform: uppercase;
                        font-weight: 600;

                    }
                }
                th.td-check{
                    padding: 0 15px !important;
                }
                tr{
                    background: none;
                    box-shadow: none;
                }
            }

            .vs-table--pagination {
                justify-content: center;
            }
        }
    }
</style>